export const TIME_PATTERN = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
export const TIME_LENGTH = 5;
